import M12 from '@img/logos/system/m12.svg';
import M18 from '@img/logos/system/m18.svg';
import MXFuel from '@img/logos/system/mxfuel.svg';
import OneKey from '@img/logos/system/onekey.svg';
import Packout from '@img/logos/system/packout.svg';
import RedLithium from '@img/logos/system/redlithiumusb.svg';
import * as React from 'react';
import { SystemLogo } from './Header.types';

export function renderSystemLogo(system: SystemLogo | undefined): React.ReactNode {
  if (system === undefined) {
    return null;
  }

  switch (system) {
    case SystemLogo.M12:
      return <M12 key={system} />;
    case SystemLogo.M18:
      return <M18 key={system} />;
    case SystemLogo.MXFuel:
      return <MXFuel key={system} />;
    case SystemLogo.RedLithium:
      return <RedLithium key={system} />;
    case SystemLogo.Packout:
      return <Packout key={system} />;
    case SystemLogo.OneKey:
      return <OneKey key={system} />;
    default:
      return null;
  }
}

export function getSystemLogoHeight(system: SystemLogo | undefined): number {
  switch (system) {
    case SystemLogo.M12:
      return 48;
    case SystemLogo.M18:
      return 48;
    case SystemLogo.MXFuel:
      return 75;
    case SystemLogo.RedLithium:
      return 53;
    case SystemLogo.Packout:
      return 23;
    case SystemLogo.OneKey:
      return 52;
    default:
      return 69;
  }
}
